import { Component } from '@theme/component';

/**
 * A custom element that handles compare functionality with toggle behavior.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement} button - The compare button element.
 *
 * @extends {Component<Refs>}
 */
class CompareTrigger extends Component {
  requiredRefs = ['button'];

  /** @type {boolean} */
  get isActive() {
    return this.classList.contains('active');
  }

  set isActive(value) {
    this.classList.toggle('active', value);
  }

  connectedCallback() {
    super.connectedCallback();
    
    // Add event listener for button click
    this.refs.button.addEventListener('click', this.handleButtonClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    // Remove event listener
    this.refs.button.removeEventListener('click', this.handleButtonClick);
  }

  /**
   * Handles the button click event.
   * @param {Event} event - The click event.
   */
  handleButtonClick = (event) => {
    event.preventDefault();

    this.isActive = !this.isActive;

    this.dispatchEvent(new CustomEvent('compare-toggle', {
      detail: {
        isActive: this.isActive
      },
      bubbles: true
    }));
  };
}

if (!customElements.get('compare-trigger')) {
  customElements.define('compare-trigger', CompareTrigger);
}
